import { render, staticRenderFns } from "./SearchWatchManagement.vue?vue&type=template&id=65100a18&"
import script from "./SearchWatchManagement.vue?vue&type=script&lang=js&"
export * from "./SearchWatchManagement.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatchManagement.vue?vue&type=style&index=0&id=65100a18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports